export default __webpack_public_path__ + "static/media/ies_KatyaKolovea.56b32b6e.png";